import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeLeaveOverview(token, monthKey) {
  const searchParams = new URLSearchParams();
  if (monthKey) {
    searchParams.set("month", monthKey);
  }

  return requestJson(`/instateam/leaves/employee/overview?${searchParams.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createEmployeeLeaveRequest(token, payload) {
  return requestJson("/instateam/leaves/employee/request", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
